<template>
  <div class="pt-4">
    <!-- START:: CHART -->
    <apexchart
      v-if="donutChartSeries"
      type="donut"
      height="450px"
      width="100%"
      :options="donutChartOptions"
      :series="donutChartSeries"
    ></apexchart>
    <!-- END:: CHART -->
  </div>
</template>

<script>
export default {
  name: "DonutChart",

  props: ["item", "labels"],

  data() {
    return {
      // START:: DONUT CHART DATA
      donutChartOptions: {
        chart: {
          type: "donut",
        },
        title: {
          text: this.$t("labels.income_month_vs_prev_month"),
          align: "center",
        },
        legend: {
          position: "bottom",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],

        labels: this.labels,
      },

      donutChartSeries: this.item,
      // END:: DONUT CHART DATA
    };
  },

  mounted() {},
};
</script>
